import Api from '../../lib/Api'
import Consts from '../../lib/Consts'
import i18n from '../../lib/i18n'
import router from '../../router'

export default {
  namespaced: true,
  state: {
    isFetching: false,
    isFetched: false,
    isError: false,
    histories: []
  },
  mutations: {
    fetchStatusBegin (state) {
      state.isFetching = true
      state.isFetched = false
      state.isError = false
    },
    fetchStatusComplete (state) {
      state.isFetching = false
      state.isFetched = true
      state.isError = false
    },
    fetchStatusError (state) {
      state.isFetching = false
      state.isFetched = true
      state.isError = true
    },
    clearHistories (state) {
      state.histories = []
    },
    setHistories (state, { histories }) {
      state.histories = histories
    }
  },
  actions: {
    async fetch ({ commit, dispatch }) {
      commit('fetchStatusBegin')
      commit('clearHistories')

      try {
        const histories = await Api.getJewelHistories()
        commit('fetchStatusComplete')
        commit('setHistories', { histories })
      } catch (e) {
        let errorMessage = 'Unknown error'
        if (e.response.data.error) {
          errorMessage = i18n.t('apiError', {
            message: e.response.data.error.message,
            code: e.response.data.error.error_code
          })
        }
        dispatch('displayAlert', { message: errorMessage }, { root: true })

        if (e.response.status === 401 && e.response.data.error.error_code === Consts.serverErrorCodes.CANNOT_AUTHENTICATE_USER) {
          commit('fetchStatusInitial')
          dispatch('session/logout', null, { root: true })
          router.replace('/auth')
          return
        }

        commit('fetchStatusError')
      }
    }
  }
}
